import { CheckboxWIthChecked } from './CheckboxWIthChecked';

export default CheckboxWIthChecked;
